import AreasOfSpecialisationApi from '../../../core/api/AreasOfSpecialisationApi'

export const events = {
  edit: {
    start: 'START_EDITING_AREAS_OF_SPECIALISATION',
    cancel: 'CANCEL_EDITING_AREAS_OF_SPECIALISATION'
  },
  fetch: {
    fetched: 'ADVISER_AREAS_OF_SPECIALISATION_PREFERENCES_FETCHED_AREAS_OF_SPECIALISATION'
  },
  set: {
    selectionChanged: 'ADVISER_AREAS_OF_SPECIALISATION_PREFERENCES_AREAS_OF_SPECIALISATION_SELECTED_CHANGED'
  }
}

const areasOfSpecialisationApi = new AreasOfSpecialisationApi()
const { edit, fetch, set } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  fetch: {
    fetchAreasOfSpecialisation: () => {
      const request = areasOfSpecialisationApi.fetchingAreasOfSpecialisation()

      return (dispatch) => {
        request.then(function (response) {
          dispatch(areasOfSpecialisationApi.handleResponse(fetch.fetched, response))
        })
      }
    }
  },
  set: {
    selectionChanged: (areaOfSpecialisation) => ({
      type: set.selectionChanged,
      areaOfSpecialisation
    })
  }
}
